module.exports = __webpack_public_path__ + "static/media/balmain.7d6e8a02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/balmain.jpg
// module id = 199
// module chunks = 0